import { render, staticRenderFns } from "./v-popper.vue?vue&type=template&id=34dd4ae5&"
import script from "./v-popper.vue?vue&type=script&lang=js&"
export * from "./v-popper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports